/* FC product grid behavior - extracted 2026-07-17. __SID is the
   section id, bridged from Liquid via window.__fcpg. */
var __SID = (window.__fcpg && window.__fcpg.sid) || '';
/* Pre-order price on cards (2026-09-11). window.__fcpgPO = { match, end, pct, cta }
   from fc-product-grid.liquid. For a variant whose option matches (iPhone Duo)
   inside the window: price = floor(price * (100 - pct) / 100) (Shopify's
   allocation for every current Duo price), null when the variant already has a
   real compare-at sale or is unavailable; cta = the "Pre-order" label. */
function __fcPgPreorder(v) {
  var c = window.__fcpgPO || {};
  if (!v || !c.match || !(c.pct > 0)) return null;
  var end = c.end ? Date.parse(c.end) : NaN;
  if (!isNaN(end) && Date.now() > end) return null;
  var m = String(c.match).toLowerCase();
  var hit = [v.o1, v.o2, v.o3].some(function (o) { return o && String(o).toLowerCase().indexOf(m) !== -1; });
  if (!hit) return null;
  var price = (v.available && !(v.compare_at_price > v.price)) ? Math.floor(v.price * (100 - c.pct) / 100) : null;
  return { price: price, cta: c.cta || 'Pre-order' };
}

(function () {
  var wrapper = document.getElementById('fc-pg-' + __SID);
  if (!wrapper) return;

  /* ── Filter/Sort sidebar ──────────────────────────── */
  var toggle   = document.getElementById('fc-filter-toggle-' + __SID);
  var layout   = document.getElementById('fc-layout-' + __SID);
  var backdrop = document.getElementById('fc-drawer-backdrop-' + __SID);
  var closeBtn = document.getElementById('fc-drawer-close-' + __SID);

  function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }

  function openSidebar() {
    if (!layout) return;
    layout.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
      toggle.classList.add('pg-filter-toggle--active');
    }
    if (isMobile()) document.body.style.overflow = 'hidden';
  }
  function closeSidebar() {
    if (!layout) return;
    layout.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.remove('pg-filter-toggle--active');
    }
    document.body.style.overflow = '';
  }
  function toggleSidebar() {
    if (!layout) return;
    if (layout.classList.contains('is-open')) closeSidebar(); else openSidebar();
  }

  if (toggle) toggle.addEventListener('click', toggleSidebar);
  if (closeBtn) closeBtn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    closeSidebar();
  });
  if (backdrop) backdrop.addEventListener('click', closeSidebar);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && layout && layout.classList.contains('is-open')) closeSidebar();
  });

  /* Close the sidebar the moment Apply is clicked (before the page reload starts) */
  var filterForm = document.getElementById('fc-filter-form-' + __SID);
  if (filterForm) {
    filterForm.addEventListener('submit', function () {
      closeSidebar();
    });
  }

  /* ── Money formatter (uses Shopify.money_format) ─── */
  /* Money (2026-09-11): window.Shopify.money_format is UNDEFINED on this
     storefront, so the old template fallback printed "$41.00" to GBP/EUR/AUD
     shoppers after every chip click. snippets/fc-money.liquid (rendered by the
     cart drawer on every page, and by this section below) exposes the active
     market's real format: fcMoneyCur = money_with_currency (main price, like
     the Liquid render), fcMoney = plain money (compare-at). */
  function formatMoney(cents) {
    if (typeof window.fcMoneyCur === 'function') return window.fcMoneyCur(cents);
    var fmt = (window.Shopify && window.Shopify.money_with_currency_format) || (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var amountNoDec = Math.round(cents / 100);
    return fmt.replace(/\{\{[\s]*amount[\s]*\}\}/g, amount)
              .replace(/\{\{[\s]*amount_no_decimals[\s]*\}\}/g, amountNoDec);
  }
  function formatMoneyPlain(cents) {
    if (typeof window.fcMoney === 'function') return window.fcMoney(cents);
    return formatMoney(cents);
  }

  /* ── "View more options" toggle ──────────────────── */
  wrapper.addEventListener('click', function (e) {
    var more = e.target.closest('.pg-card__more-toggle');
    if (!more) return;
    var card = more.closest('.pg-card');
    if (!card) return;
    var expanded = card.classList.toggle('pg-card--expanded');
    more.setAttribute('aria-expanded', String(expanded));
    var txt = more.querySelector('.pg-more-txt');
    if (txt) {
      if (expanded) {
        txt.textContent = 'View less';
      } else {
        var count = card.querySelectorAll('.pg-card__option--extra').length;
        txt.textContent = '+ ' + count + ' more ' + (count === 1 ? 'option' : 'options');
      }
    }
  });

  /* ── Per-card "Choose Options" modal (mobile) ────── */
  var cardBackdrop = document.getElementById('fc-card-backdrop-' + __SID);

  function closeCardModal() {
    wrapper.querySelectorAll('.pg-card--modal-open').forEach(function (c) {
      c.classList.remove('pg-card--modal-open');
    });
    if (cardBackdrop) cardBackdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  wrapper.addEventListener('click', function (e) {
    /* Choose Options button → open this card's modal */
    var chooseBtn = e.target.closest('.pg-card__choose-btn');
    if (chooseBtn && !chooseBtn.disabled) {
      var card = chooseBtn.closest('.pg-card');
      if (card) {
        /* Close any other open card modals first */
        wrapper.querySelectorAll('.pg-card--modal-open').forEach(function (c) {
          if (c !== card) c.classList.remove('pg-card--modal-open');
        });
        card.classList.add('pg-card--modal-open');
        if (cardBackdrop) cardBackdrop.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
      return;
    }
    /* Modal close (X) button */
    var modalCloseBtn = e.target.closest('.pg-card__modal-close');
    if (modalCloseBtn) {
      e.preventDefault();
      closeCardModal();
      return;
    }
    /* Add to Cart click inside the modal → close modal after AJAX add fires */
    var atcBtn = e.target.closest('.pg-atc');
    if (atcBtn && !atcBtn.disabled) {
      var atcCard = atcBtn.closest('.pg-card');
      if (atcCard && atcCard.classList.contains('pg-card--modal-open')) {
        setTimeout(closeCardModal, 250);
      }
    }
  });

  if (cardBackdrop) cardBackdrop.addEventListener('click', closeCardModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && wrapper.querySelector('.pg-card--modal-open')) closeCardModal();
  });

  /* ── Option picker: click a swatch/pill → update variant ── */
  wrapper.addEventListener('click', function (e) {
    var btn = e.target.closest('.pg-opt-btn');
    if (!btn) return;

    var optRow = btn.closest('.pg-card__option');
    var card   = btn.closest('.pg-card');
    if (!optRow || !card) return;

    var pos    = parseInt(optRow.dataset.optionPos, 10); // 1, 2, 3
    var val    = btn.dataset.value;
    var formId = optRow.dataset.formId;

    /* Update selected state on the buttons + wrappers in this row */
    optRow.querySelectorAll('.pg-val-btn').forEach(function (b) {
      b.classList.remove('pg-val-btn--selected');
    });
    optRow.querySelectorAll('.pg-val').forEach(function (w) {
      w.classList.remove('pg-val--selected');
    });
    btn.classList.add('pg-val-btn--selected');
    var wrap = btn.closest('.pg-val');
    if (wrap) wrap.classList.add('pg-val--selected');

    /* Update "Model: X" label text */
    var lbl = optRow.querySelector('.pg-card__option-val');
    if (lbl) lbl.textContent = val;

    /* Track selection on the card dataset */
    card.dataset['selO' + pos] = val;

    /* Colour chip thumbnails follow the selected MODEL (2026-09-18): each chip
       carries a model→image map from Liquid (pairs without the outer braces). */
    (function syncChipImages() {
      var optsWrap = card.querySelector('.pg-card__options');
      var mpos = optsWrap ? parseInt(optsWrap.dataset.fcMpos, 10) : 0;
      if (!(mpos > 0)) return;
      var modelVal = card.dataset['selO' + mpos] || '';
      card.querySelectorAll('.pg-val-btn img[data-img-map]').forEach(function (im) {
        try {
          var map = JSON.parse('{' + im.getAttribute('data-img-map') + '}');
          var want = map[modelVal];
          if (want && im.getAttribute('src') !== want) { im.src = want; im.removeAttribute('srcset'); }
        } catch (err) {}
      });
    })();

    /* Find matching variant across ALL selected options */
    var dataEl = card.querySelector('.pg-variant-data');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var selO1 = card.dataset.selO1 || '';
    var selO2 = card.dataset.selO2 || '';
    var selO3 = card.dataset.selO3 || '';

    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match1 = !selO1 || (v.o1 === selO1) || v.o1 === null;
      var match2 = !selO2 || (v.o2 === selO2) || v.o2 === null;
      var match3 = !selO3 || (v.o3 === selO3) || v.o3 === null;
      if (match1 && match2 && match3) {
        if (v.available) { match = v; break; }
        if (!match) match = v; /* fallback to unavailable if no available match */
      }
    }
    if (!match) return;
    var fcPo = __fcPgPreorder(match);

    /* Update hidden form id */
    var form = document.getElementById(formId);
    if (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = match.id;
    }

    /* Carry the chosen variant into the card's product links (2026-09-11):
       on style collections (Magnetic, Hinge Cover, ...) a shopper who taps
       "iPhone Duo" on a card expects the PDP to open on iPhone Duo, not on
       the product's default Galaxy variant. Keeps the /collections/<x>/
       prefix so the PDP context (fc-collection-family) is unchanged. */
    if (match.id) {
      card.querySelectorAll('a.pg-card__img-link, .pg-card__title a').forEach(function (a) {
        var h = a.getAttribute('href') || '';
        if (h.indexOf('/products/') === -1) return;
        var base = h.split('#')[0].split('?')[0];
        var qs = (h.split('?')[1] || '').split('#')[0].split('&').filter(function (kv) { return kv && kv.indexOf('variant=') !== 0; });
        qs.push('variant=' + match.id);
        a.setAttribute('href', base + '?' + qs.join('&'));
      });
    }

    /* Update ATC button state */
    var atc = card.querySelector('.pg-atc');
    if (atc && atc.tagName === 'BUTTON') {
      var atcSpan = atc.querySelector('span') || atc;
      if (match.available) {
        atc.classList.remove('pg-atc--disabled');
        atcSpan.textContent = (fcPo && fcPo.cta) ? fcPo.cta : ((window.__fcpgT && window.__fcpgT.atc) || 'Add to Cart');
        atc.disabled = false;
        atc.removeAttribute('aria-disabled');
      } else {
        atc.classList.add('pg-atc--disabled');
        atcSpan.textContent = ((document.documentElement.lang || '').slice(0, 2) === 'de') ? 'Ausverkauft' : 'Sold Out';
        atc.disabled = true;
        atc.setAttribute('aria-disabled', 'true');
      }
    }

    /* Update main product image to the variant's image */
    if (match.img) {
      var primary = card.querySelector('.pg-card__img--primary');
      if (primary && primary.src !== match.img) {
        primary.src = match.img;
        primary.removeAttribute('srcset');
      }
      /* Slide 1 is the only colour-specific slide, so after a colour change a
         shopper parked on slide 3 would be looking at the previous choice's
         context. Snap back so the new colour is what they see. */
      var galTrack = card.querySelector('[data-pg-gal-track]');
      if (galTrack && galTrack.scrollLeft > 0) galTrack.scrollLeft = 0;
    }

    /* Colour-set gallery (2026-09-10): rebuild the extra slides so they are the
       selected colour's own photos (+ shared images), mirroring the product
       page. Data comes from the per-card .pg-gal-data JSON rendered by Liquid. */
    (function rebuildColourSlides() {
      var dataNode = card.querySelector('.pg-gal-data');
      var gal = card.querySelector('[data-pg-gal]');
      var track = gal && gal.querySelector('[data-pg-gal-track]');
      if (!dataNode || !gal || !track) return;
      var gd;
      try { gd = JSON.parse(dataNode.textContent); } catch (err) { return; }
      var colour = match['o' + gd.cpos];
      if (colour == null) return;
      var own = (gd.groups && gd.groups[colour]) || [];
      var shared = (gd.groups && gd.groups['*']) || [];
      /* Device family (2026-09-11): drop the other family's files for the selected Model. */
      var dev = null;
      if (gd.devices && gd.mpos) {
        dev = /iphone/i.test(String(match['o' + gd.mpos] || '')) ? 'iphone' : 'galaxy';
      }
      var list = own.concat(shared).filter(function (m) {
        if (m.id === match.mid) return false;
        if (dev && m.d && m.d !== '*' && m.d !== dev) return false;
        return true;
      }).slice(0, gd.max || 4);
      var primary = track.querySelector('.pg-card__img-link');
      if (!primary) return;
      var href = primary.getAttribute('href') || '#';
      var label = primary.getAttribute('aria-label') || '';
      /* Drop every slide except the primary one, then append the new set. */
      track.querySelectorAll('.pg-gal__slide').forEach(function (s) { if (s !== primary) s.parentNode.removeChild(s); });
      var frag = document.createDocumentFragment();
      list.forEach(function (m) {
        var a = document.createElement('a');
        a.href = href; a.className = 'pg-card__img-link pg-gal__slide'; a.tabIndex = -1; a.setAttribute('aria-label', label);
        var img = document.createElement('img');
        img.className = 'pg-card__img'; img.src = m.src; img.alt = m.alt || '';
        if (m.w) img.width = m.w; if (m.h) img.height = m.h;
        img.loading = 'lazy'; img.decoding = 'async';
        if (/[?&]width=500/.test(m.src)) img.srcset = m.src.replace(/([?&])width=500/, '$1width=300') + ' 300w, ' + m.src + ' 500w';
        if (gd.sizes) img.sizes = gd.sizes;
        a.appendChild(img); frag.appendChild(a);
      });
      track.appendChild(frag);
      /* Dots: one per slide (primary + extras). */
      var dots = gal.querySelector('.pg-gal__dots');
      if (dots) {
        dots.innerHTML = '';
        for (var d = 0; d <= list.length; d++) {
          var dot = document.createElement('span');
          dot.className = 'pg-gal__dot' + (d === 0 ? ' is-on' : '');
          dots.appendChild(dot);
        }
      }
      gal.classList.toggle('pg-gal--single', list.length === 0);
      track.scrollLeft = 0;
      /* Let the gallery module re-sync arrows/dots via its scroll listener. */
      track.dispatchEvent(new Event('scroll'));
    })();

    /* Update price (main + modal) */
    if (match.price !== undefined) {
      var poP = (fcPo && fcPo.price != null) ? fcPo.price : null;
      var p = formatMoney(poP != null ? poP : match.price);
      var cp = (match.compare_at_price > match.price) ? formatMoneyPlain(match.compare_at_price) : (poP != null ? formatMoneyPlain(match.price) : null);
      var html;
      if (!match.available) {
        html = '<span class="pg-price-soldout">' + p + '</span>';
      } else if (cp) {
        html = '<span class="pg-price-sale">' + p + '</span><span class="pg-price-compare">' + cp + '</span>';
      } else {
        html = '<span class="pg-price-regular">' + p + '</span>';
      }
      card.querySelectorAll('.pg-card__price').forEach(function (priceEl) {
        priceEl.innerHTML = html;
      });
    }
  });

})();

(function() {
  var sid = __SID;
  var root = document.getElementById('fc-pg-' + sid);
  if (!root) return;
  var container = root.querySelector('[data-fc-feature-filters]');
  if (!container) return;

  var chips = container.querySelectorAll('.pg-feature-chip');
  var clearBtn = container.querySelector('[data-fc-feature-clear]');
  var hiddenInput = container.querySelector('[data-fc-features-hidden]');
  var applyBtn = root.querySelector('.pg-drawer__apply');
  var countEl = root.querySelector('.pg-bar__count');
  var originalCountText = countEl ? countEl.textContent : '';

  // ---- URL state (chips are committed to URL only on Apply, then auto-re-applied on load) ----
  function getUrlFeatures() {
    var params = new URLSearchParams(window.location.search);
    return (params.get('fc_features') || '').split(',').map(function(s){return s.trim();}).filter(Boolean);
  }

  function chipHandles(chip) {
    return (chip.getAttribute('data-fc-feature-handles') || '').split(',').map(function(s){return s.trim();}).filter(Boolean);
  }

  // For matching a chip to an URL-feature list, ANY of its handles count.
  function chipIsActive(chip, urlHandles) {
    return chipHandles(chip).some(function(h) { return urlHandles.indexOf(h) !== -1; });
  }

  // Read current PENDING chip state (whatever the user has toggled in the UI)
  function getPendingHandles() {
    var handles = [];
    chips.forEach(function(c) {
      if (c.getAttribute('aria-pressed') === 'true') {
        handles = handles.concat(chipHandles(c));
      }
    });
    // Dedupe
    return handles.filter(function(h, i){ return handles.indexOf(h) === i; });
  }

  // Sync hidden input with PENDING state — so form submit carries it forward
  function syncHidden() {
    if (hiddenInput) hiddenInput.value = getPendingHandles().join(',');
  }

  // Visually mark pending dot if chip state differs from committed URL state
  function syncPendingDots() {
    var urlHandles = getUrlFeatures();
    chips.forEach(function(c) {
      var nowPressed = c.getAttribute('aria-pressed') === 'true';
      var wasActive = chipIsActive(c, urlHandles);
      if (nowPressed !== wasActive) c.setAttribute('data-fc-pending', 'true');
      else c.removeAttribute('data-fc-pending');
    });
    // Update Apply button label with count of pending features (visual signal that there are unsaved changes)
    if (applyBtn) {
      var anyPending = Array.prototype.some.call(chips, function(c) {
        return c.hasAttribute('data-fc-pending');
      });
      applyBtn.setAttribute('data-fc-pending', anyPending ? 'true' : 'false');
    }
  }

  // APPLY filter visuals (called on page load only — chip clicks do NOT call this)
  function applyFilterVisuals(activeHandles) {
    var cards = root.querySelectorAll('.pg-card');
    var visibleCount = 0;
    cards.forEach(function(card) {
      if (activeHandles.length === 0) {
        card.removeAttribute('data-fc-hidden');
        visibleCount++;
        return;
      }
      var colls = (card.getAttribute('data-fc-collections') || '').split(',');
      var matches = activeHandles.some(function(h) { return colls.indexOf(h) !== -1; });
      if (matches) {
        card.removeAttribute('data-fc-hidden');
        visibleCount++;
      } else {
        card.setAttribute('data-fc-hidden', 'true');
      }
    });
    // Update product count
    if (countEl) {
      if (activeHandles.length === 0) {
        countEl.textContent = originalCountText;
      } else {
        countEl.textContent = visibleCount + (visibleCount === 1 ? ' product' : ' products');
      }
    }
  }

  // ---- Page-load init: read URL → set chip states + apply filter to product cards ----
  var urlHandles = getUrlFeatures();
  chips.forEach(function(c) {
    c.setAttribute('aria-pressed', chipIsActive(c, urlHandles) ? 'true' : 'false');
  });
  syncHidden();
  applyFilterVisuals(urlHandles);
  if (clearBtn) clearBtn.hidden = (urlHandles.length === 0);

  // ---- Chip click: toggle visual only (PENDING). Don't filter or change URL until Apply. ----
  chips.forEach(function(chip) {
    chip.addEventListener('click', function() {
      var pressed = chip.getAttribute('aria-pressed') === 'true';
      chip.setAttribute('aria-pressed', pressed ? 'false' : 'true');
      syncHidden();
      syncPendingDots();
      // Show "Clear" button if any chip is now pressed
      if (clearBtn) {
        var anyPressed = Array.prototype.some.call(chips, function(c) { return c.getAttribute('aria-pressed') === 'true'; });
        clearBtn.hidden = !anyPressed;
      }
    });
  });

  // ---- Local "Clear" (next to chips): reset all chips to unpressed. Doesn't auto-apply. ----
  if (clearBtn) {
    clearBtn.addEventListener('click', function() {
      chips.forEach(function(c) { c.setAttribute('aria-pressed', 'false'); });
      syncHidden();
      syncPendingDots();
      clearBtn.hidden = true;
    });
  }
})();

(function(){
  if (window.fcGridAtcHooked) return;
  window.fcGridAtcHooked = true;

  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || !form.matches) return;
    // Match Dawn's product-form by data-type attribute (set in fc-product-grid markup)
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;
    // Only intercept if the form is inside a fc-product-grid section
    if (!form.closest('[id^="fc-pg-"]')) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    var btn = form.querySelector('button[name="add"], button[type="submit"]');
    if (!btn || btn.hasAttribute('disabled')) return;
    var label = btn.querySelector('span') || btn;
    var originalText = label ? label.textContent : '';
    btn.setAttribute('disabled', 'disabled');
    if (label) label.textContent = (window.__fcpgT && window.__fcpgT.adding) || 'Adding…';

    var formData = new FormData(form);
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function(r){
        if (!r.ok) return r.json().then(function(err){ throw err; });
        return r.json();
      })
      .then(function(response){
        // Chain /cart.js so the cart icon bubble + drawer total stay in sync
        return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
          response.item_count = cart.item_count;
          response.total_price = cart.total_price;
          return response;
        }).catch(function(){ return response; });
      })
      .then(function(response){
        if (label) label.textContent = (window.__fcpgT && window.__fcpgT.added) || '✓ Added';
        var drawer = document.querySelector('cart-drawer');
        if (drawer && response.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(response);
          // is-empty class persists on the wrapper after renderContents
          // (saved memory: feedback_dawn_drawer_is_empty)
          drawer.classList.remove('is-empty');
        } else if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));
        if (window.FoldifyCart && typeof window.FoldifyCart.show === 'function') {
          window.FoldifyCart.show(response);
        }
        setTimeout(function(){
          btn.removeAttribute('disabled');
          if (label) label.textContent = originalText || (window.__fcpgT && window.__fcpgT.atc) || 'Add to Cart';
        }, 1200);
      })
      .catch(function(err){
        btn.removeAttribute('disabled');
        if (label) label.textContent = originalText || (window.__fcpgT && window.__fcpgT.atc) || 'Add to Cart';
        var msg = (err && err.description) || (err && err.message) || 'Could not add to cart.';
        if (window.FoldifyCart && typeof window.FoldifyCart.error === 'function') {
          window.FoldifyCart.error(msg);
        } else if (window.console) {
          console.warn('[fc-grid] ATC failed:', msg);
        }
      });
  }, true); // capture: true — runs before bubble-phase third-party handlers
})();

(function () {
  var root = document.getElementById('fc-pg-' + __SID);
  if (!root) return;
  function mark(img) {
    var media = img.closest('.pg-card__media');
    if (media) media.classList.add('is-imgloaded');
  }
  root.querySelectorAll('.pg-card__img--primary').forEach(function (img) {
    if (img.complete && img.naturalWidth > 0) mark(img);
  });
  // 'load' doesn't bubble — listen in capture phase.
  root.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('pg-card__img--primary')) mark(t);
  }, true);
})();

/* ── Return-to-position on back navigation (2026-08-06) ───────────────
   Problem: tapping a product then hitting Back dumped shoppers at the
   TOP of the collection — verified 2134px -> 0. The browser's native
   restore fails here because the returning page is short at restore
   time (below-fold sections use content-visibility:auto and images are
   lazy), so the saved offset is clamped away.

   Fix: remember the tapped card, then on return scroll to THAT CARD
   (falling back to the raw offset). Anchoring to the element rather
   than a pixel value survives any layout shift — reflowed grid, a
   sold-out card disappearing, a different viewport after rotation.
   Re-applies for ~1.2s while lazy content settles, and aborts the
   moment the shopper scrolls themselves so we never fight them.       */
(function () {
  var grid = document.querySelector('.fc-pg');
  if (!grid || !('sessionStorage' in window)) return;

  var KEY = 'fcpg:pos:' + location.pathname + location.search;
  var MAX_AGE = 30 * 60 * 1000; // stale positions are worse than none

  // We restore ourselves; stop the browser doing a conflicting jump.
  try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}

  // ── Save on the way out ──
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!link || !grid.contains(link)) return;
    var card = link.closest('.pg-card');
    var id = card ? (card.getAttribute('data-fc-card-id') || '') : '';
    if (card && !id) {
      // Stable-enough identifier: the product path of the card's link.
      id = (link.getAttribute('href') || '').split('?')[0];
      card.setAttribute('data-fc-card-id', id);
    }
    try {
      sessionStorage.setItem(KEY, JSON.stringify({
        y: window.scrollY || window.pageYOffset || 0,
        id: id,
        t: Date.now()
      }));
    } catch (err) {}
  }, true);

  // ── Restore on the way back ──
  function restore() {
    var raw;
    try { raw = sessionStorage.getItem(KEY); } catch (e) { return; }
    if (!raw) return;
    var saved;
    try { saved = JSON.parse(raw); } catch (e) { return; }
    try { sessionStorage.removeItem(KEY); } catch (e) {}
    if (!saved || Date.now() - saved.t > MAX_AGE) return;
    if (!saved.y && !saved.id) return;

    var cancelled = false;
    function cancel() { cancelled = true; }
    // Any genuine user input wins immediately.
    ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (ev) {
      window.addEventListener(ev, cancel, { once: true, passive: true });
    });

    function apply() {
      if (cancelled) return;
      var target = null;
      if (saved.id) {
        var link = grid.querySelector('a[href^="' + saved.id + '"]');
        var card = link && link.closest('.pg-card');
        if (card) {
          var r = card.getBoundingClientRect();
          target = (window.scrollY || window.pageYOffset || 0) + r.top
                   - Math.max(0, (window.innerHeight - r.height) / 2);
        }
      }
      if (target === null) target = saved.y;
      target = Math.max(0, Math.min(target,
        document.documentElement.scrollHeight - window.innerHeight));
      if (Math.abs((window.scrollY || 0) - target) > 4) window.scrollTo(0, target);
    }

    apply();
    // Lazy sections/images keep changing the height for a beat — keep
    // re-applying briefly so the landing spot stays correct.
    var start = Date.now();
    var iv = setInterval(function () {
      if (cancelled || Date.now() - start > 1200) { clearInterval(iv); return; }
      apply();
    }, 100);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') restore();
  else document.addEventListener('DOMContentLoaded', restore);

  // bfcache returns already have the right scroll position — just clear
  // the saved entry so a later fresh load doesn't jump unexpectedly.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { try { sessionStorage.removeItem(KEY); } catch (err) {} }
  });
})();

/* ── Liquid-glass traveling selection ring (2026-08-22) ─────────────────
   One ring per option row glides to the tapped swatch with the droplet
   stretch + spring settle used by the fc-moments tab capsule. Runs AFTER
   the main option-click handler (document-level listener fires later in
   the bubble), so the --selected classes are already updated. Lazy: the
   ring is created on first interaction; until then the static CSS ring
   shows. Honors prefers-reduced-motion. */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function placeRing(ring, row, btn, animate) {
    var rr = row.getBoundingClientRect();
    var rb = btn.getBoundingClientRect();
    var to = { left: rb.left - rr.left, top: rb.top - rr.top, w: rb.width, h: rb.height };
    var hadPos = ring.style.width !== '';
    var from = hadPos ? {
      left: parseFloat(ring.style.left), top: parseFloat(ring.style.top),
      w: parseFloat(ring.style.width), h: parseFloat(ring.style.height)
    } : null;
    ring.style.left = to.left + 'px';
    ring.style.top = to.top + 'px';
    ring.style.width = to.w + 'px';
    ring.style.height = to.h + 'px';
    if (!animate || !from || reduce || typeof ring.animate !== 'function') return;
    /* Gel morph per Apple's Liquid Glass motion (tuned 2026-08-22):
       slower flight so the shape-read is clear — circle STRETCHES into a
       droplet mid-flight, compresses tall on arrival (gel squash), then
       relaxes back to a circle with a small rebound. */
    var dx = to.left - from.left;
    var sameLine = Math.abs(to.top - from.top) < 4;
    var midW = sameLine
      ? Math.min(Math.abs(dx) * 0.6 + to.w, to.w * 2.4)
      : to.w * 1.2;
    var midL = sameLine
      ? (dx >= 0 ? from.left + dx * 0.25 : from.left + dx * 0.75)
      : from.left + dx * 0.5;
    var midTop = (from.top + to.top) / 2 + (to.h - to.h * 0.88) / 2;
    var squashW = to.w * 0.92, squashH = to.h * 1.06;
    var reboundW = to.w * 1.04, reboundH = to.h * 0.97;
    if (ring.__anim) ring.__anim.cancel();
    ring.__anim = ring.animate([
      { left: from.left + 'px', top: from.top + 'px', width: from.w + 'px', height: from.h + 'px', offset: 0 },
      { left: midL + 'px', top: midTop + 'px', width: midW + 'px', height: (to.h * 0.88) + 'px', offset: 0.38 },
      { left: (to.left + (to.w - squashW) / 2) + 'px', top: (to.top - (squashH - to.h) / 2) + 'px', width: squashW + 'px', height: squashH + 'px', offset: 0.68 },
      { left: (to.left + (to.w - reboundW) / 2) + 'px', top: (to.top + (to.h - reboundH) / 2) + 'px', width: reboundW + 'px', height: reboundH + 'px', offset: 0.85 },
      { left: to.left + 'px', top: to.top + 'px', width: to.w + 'px', height: to.h + 'px', offset: 1 }
    ], { duration: 650, easing: 'cubic-bezier(0.3, 0.75, 0.35, 1)' });
  }

  /* Capture phase: snapshot the PREVIOUS selection before the main
     handler (bubble phase) moves the --selected class — this is what lets
     the very first interaction animate from the old swatch (bugfix
     2026-08-22: previously the lazy ring seated instantly on first click
     and only animated from the second click on). */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pg-opt-btn');
    if (!btn || !btn.closest('.fc-pg')) return;
    var row = btn.closest('.pg-card__option');
    if (row) row.__prevSel = row.querySelector('.pg-val-btn--selected');
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pg-opt-btn');
    if (!btn || !btn.closest('.fc-pg')) return;
    var row = btn.closest('.pg-card__option');
    if (!row) return;
    /* the main handler (earlier in the bubble) has set --selected */
    var selected = row.querySelector('.pg-val-btn--selected');
    if (!selected) return;
    var ring = row.querySelector(':scope > .pg-sel-ring');
    if (!ring) {
      ring = document.createElement('span');
      ring.className = 'pg-sel-ring';
      row.appendChild(ring);
      row.classList.add('has-sel-ring');
      /* seat the fresh ring at the OLD selection so its first flight
         animates like every later one */
      if (row.__prevSel && row.__prevSel !== selected) {
        placeRing(ring, row, row.__prevSel, false);
      }
    }
    placeRing(ring, row, selected, true);
  });

  var rafId = null;
  window.addEventListener('resize', function () {
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      document.querySelectorAll('.pg-card__option.has-sel-ring').forEach(function (row) {
        var ring = row.querySelector(':scope > .pg-sel-ring');
        var selected = row.querySelector('.pg-val-btn--selected');
        if (ring && selected) placeRing(ring, row, selected, false);
      });
    });
  });
})();

/* ── Card image gallery (2026-09-01) ──────────────────────────────────────
   The swiping itself is native CSS scroll-snap - this only adds the desktop
   arrows, the dot indicator, and one guard: a horizontal swipe must not fall
   through as a tap on the product link. Everything is delegated off the grid
   root so it survives any card being re-rendered. */
(function () {
  if (window.pgGalInstalled) return;
  window.pgGalInstalled = true;

  var root = document.getElementById('fc-pg-' + __SID);
  if (!root) return;

  function trackOf(el) { return el.closest('[data-pg-gal]').querySelector('[data-pg-gal-track]'); }

  function sync(gal) {
    var track = gal.querySelector('[data-pg-gal-track]');
    if (!track) return;
    var w = track.clientWidth || 1;
    var i = Math.round(track.scrollLeft / w);
    var n = gal.querySelectorAll('.pg-gal__slide').length;
    var dots = gal.querySelectorAll('.pg-gal__dot');
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === i);
    var prev = gal.querySelector('[data-pg-gal-prev]');
    var next = gal.querySelector('[data-pg-gal-next]');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= n - 1;
  }

  /* Arrows. stopPropagation so the click never reaches the card link. */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pg-gal-prev], [data-pg-gal-next]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var track = trackOf(btn);
    if (!track) return;
    var dir = btn.hasAttribute('data-pg-gal-next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
  });

  /* A swipe is a scroll, not a tap. Browsers usually suppress the click after a
     scroll, but not reliably once the gesture starts on an <a>. Capture phase so
     this runs before the link's own default action. */
  root.addEventListener('pointerdown', function (e) {
    var track = e.target.closest && e.target.closest('[data-pg-gal-track]');
    if (track) { track._x = e.clientX; track._drag = false; }
  }, true);
  root.addEventListener('pointermove', function (e) {
    var track = e.target.closest && e.target.closest('[data-pg-gal-track]');
    if (track && track._x != null && Math.abs(e.clientX - track._x) > 10) track._drag = true;
  }, true);
  root.addEventListener('click', function (e) {
    var track = e.target.closest && e.target.closest('[data-pg-gal-track]');
    if (track && track._drag) { e.preventDefault(); e.stopPropagation(); track._drag = false; }
  }, true);

  /* Dot sync, coalesced to one frame per scroll burst. */
  var gals = root.querySelectorAll('[data-pg-gal]');
  for (var g = 0; g < gals.length; g++) {
    (function (gal) {
      var track = gal.querySelector('[data-pg-gal-track]');
      if (!track) return;
      var pending = false;
      track.addEventListener('scroll', function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; sync(gal); });
      }, { passive: true });
      sync(gal);
    })(gals[g]);
  }
})();

/* ── Detected phone → pre-select that model on every card (2026-10-08) ──
   Ad visitors land on a collection with every card defaulting to the first
   model (Fold 8 Ultra). The header already ships snippets/fc-phone-detect
   (window.fcDetectPhone, Android UA-CH / UA string → "Galaxy Z Fold 7").
   When it resolves, click the matching model chip on each card so price,
   images and the add-to-cart variant follow — same path as a real tap — and
   say so above the grid. Skips cards without that model or where it is
   sold out, never fires on iPhone (the helper does not resolve there), and
   runs once per page view. */
(function () {
  var root = document.querySelector('.fc-pg');
  if (!root || window.__fcpgDetectApplied) return;
  var tries = 0;
  function start() {
    if (typeof window.fcDetectPhone !== 'function') {
      if (tries++ < 20) setTimeout(start, 250);     // header snippet may load after this deferred asset
      return;
    }
    window.fcDetectPhone(function (name) {
      if (!name || window.__fcpgDetectApplied) return;
      window.__fcpgDetectApplied = true;
      var want = String(name).toLowerCase().trim();
      var hits = 0;
      root.querySelectorAll('.pg-card').forEach(function (card) {
        var opts = card.querySelector('.pg-card__options');
        var mpos = opts ? parseInt(opts.dataset.fcMpos, 10) : 0;
        if (!mpos) return;
        var row = card.querySelector('.pg-card__option[data-option-pos="' + mpos + '"]');
        if (!row) return;
        var btn = null;
        row.querySelectorAll('.pg-opt-btn').forEach(function (b) {
          if (!btn && String(b.dataset.value || '').toLowerCase().trim() === want) btn = b;
        });
        if (!btn) return;
        var wrap = btn.closest('.pg-val');
        if (wrap && wrap.classList.contains('pg-val--soldout')) return;
        if (btn.classList.contains('pg-val-btn--selected')) { hits++; return; }
        try { btn.click(); hits++; } catch (e) {}
      });
      if (!hits) return;
      var bar = root.querySelector('.pg-bar__left');
      var tpl = (window.__fcpgT && window.__fcpgT.detectNote) || 'Pre-selected for your {model} – change the model on any card.';
      if (bar && !bar.querySelector('.pg-bar__detect')) {
        var note = document.createElement('span');
        note.className = 'pg-bar__detect';
        note.setAttribute('role', 'status');
        note.textContent = tpl.replace('{model}', name);
        bar.appendChild(note);
      }
    });
  }
  start();
})();
